import { useQuery } from "@tanstack/react-query";
import { getStoreContactsByStoreId } from "../services/storeContacts.service";

const useStoreContacts = (storeId: string) => {
  return useQuery({
    queryKey: ["store-contacts", storeId],
    queryFn: () => getStoreContactsByStoreId(storeId),
    staleTime: 1000 * 60 * 60 * 24 * 7,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};

export default useStoreContacts;
